import { defineMessages } from 'react-intl';
import { text as textConstants } from 'content-creation-common/constants';

export const {
  DEFAULT_STROKE_COLOR,
  DEFAULT_STROKE_WIDTH,
  HIGHLIGHT_SIZE_OPTIONS,
  OVERFLOW_X,
  OVERFLOW_Y,
  TEXT_EFFECTS,
  TEXT_FILL,
  TEXT_TYPE,
  UNICODES,
  VERTICAL_TEXT_ALIGNMENT,
} = textConstants;

export const DEFAULT_VERTICAL_TEXT_ALIGNMENT = VERTICAL_TEXT_ALIGNMENT.TOP;
export const DEFAULT_TEXT_TYPE = TEXT_TYPE.CANVAS;

export const DEFAULT_TEXT_WRAP_BOX_WIDTH_IN_PIXELS = 1000;
export const DEFAULT_TEXT_WRAP_BOX_HEIGHT_IN_PIXELS = 500;

export const FONT_SIZE_MIN_IN_PIXELS = 24;
export const FONT_SIZE_MAX_IN_PIXELS = 1200;

export const DEFAULT_BROWSER_FONT = {
  id: '',
  psName: 'SDS-Font',
  displayName: 'Avenir Next (default)',
};

export const DEFAULT_TEXT_FONT = {
  id: '',
  psName: 'NeuzeitOfficeW05-Bold',
  displayName: 'Neuzeit® Office W05 Bold (default)',
};

export const DEFAULT_FONT_SIZE = 75;
export const DEFAULT_FONT_PSNAME = DEFAULT_TEXT_FONT.psName;
export const ALTERNATE_FONT_PREVIEW_SET = 'quickfox';

export const MAX_TEXT_CHARS = 4800;

export const OVERFLOW_Y_LABELS = defineMessages({
  ELLIPSIS: {
    defaultMessage: 'Ellipsis',
    description:
      'Label for text behavior that results in text being truncated with an ellipsis when overflowing',
  },
  HIDDEN: {
    defaultMessage: 'Hidden',
    description:
      'Label for text behavior that results in text being hidden when overflowing',
  },
  VISIBLE: {
    defaultMessage: 'Visible',
    description:
      'Label for text behavior that results in text being visible when overflowing',
  },
});

export const OVERFLOW_Y_ORDERED = [
  OVERFLOW_Y.VISIBLE,
  OVERFLOW_Y.HIDDEN,
  OVERFLOW_Y.ELLIPSIS,
];

export const DEFAULT_TEXT_FILL = TEXT_FILL.ABSOLUTE;

export const TEXT_FILL_LABELS = defineMessages({
  ABSOLUTE: {
    defaultMessage: 'Absolute',
    description:
      'Label for text fill behavior, indicates given font size will be used',
  },
  AUTO: {
    defaultMessage: 'Auto',
    description:
      'Label for text fill behavior, indicates font size will be automatically selected',
  },
  GROW_TO_FIT: {
    defaultMessage: 'Headline (Grow only)',
    description:
      'Label for text fill behavior, indicates font size will be automatically selected as long as it is bigger than the current setting',
  },
  SHRINK_TO_FIT: {
    defaultMessage: 'Body (Shrink only)',
    description:
      'Label for text fill behavior, indicates font size will be automatically selected as long as it is smaller than the current setting',
  },
});

export const TEXT_FILL_ORDERED = [
  TEXT_FILL.ABSOLUTE,
  TEXT_FILL.GROW_TO_FIT,
  TEXT_FILL.SHRINK_TO_FIT,
  TEXT_FILL.AUTO,
];

export const VALID_TEXT_FILL = new Set(TEXT_FILL_ORDERED);

export const DEPRECATED_TEXT_EFFECTS_FOR_CANVAS_TEXT = new Set([
  TEXT_EFFECTS.BEVEL,
  TEXT_EFFECTS.DROP_SHADOW_OUTLINE,
  TEXT_EFFECTS.FIT_LINE_FILL,
  TEXT_EFFECTS.LINE_FILL,
  TEXT_EFFECTS.OUTLINE_STROKE,
]);

export const DEPRECATED_TEXT_EFFECT_STROKE_COLOR = '#000000';

export const DEFAULT_FONT_PROPERTIES = {
  color: '#FFFFFF',
  fontSize: DEFAULT_FONT_SIZE,
  strokeColor: DEFAULT_STROKE_COLOR,
  strokeWidth: DEFAULT_STROKE_WIDTH,
  textEffect: TEXT_EFFECTS.HIGHLIGHT,
};
